<template>
  <div class="form-wrap" v-if="isValid">
    <div class="input">
      <span>{{$t('adminUserManagement.newPassword')}}</span>
      <div class="item">
        <input type="password"
          v-model="password.value"
          @focus="password.errors = []"
          :placeholder="$t('resetPassword.newPasswordPlaceholder')"
          :class="{error: password.errors.length > 0}"
          @keypress.enter="resetPassword"
        >
      </div>
      <small v-for="(error, index) in password.errors"
        :key="index"
      >{{ error }}</small>
    </div>
    <div class="input">
      <span>{{$t('adminUserManagement.confirmNewPassword')}}</span>
      <div class="item">
        <input type="password"
          v-model="repeatPassword.value"
          @focus="repeatPassword.errors = []"
          :placeholder="$t('resetPassword.repeatNewPasswordPlaceholder')"
          :class="{error: repeatPassword.errors.length > 0}"
          @keypress.enter="resetPassword"
        >
      </div>
      <small v-for="(error, index) in repeatPassword.errors"
        :key="index"
      >{{ error }}</small>
    </div>
  
    <div class="button-wrap">
      <div class="button-round" @click="resetPassword">{{$t('button.confirm')}} &nbsp;<span class="material-icons">arrow_right_alt</span></div>
    </div>
  </div>
</template>

<script>
import api from  '@/api';
export default {
  data() {
    return {
      password: {
        value: '',
        errors: []
      },
      repeatPassword: {
        value: '',
        errors: []
      },
      isValid: false,
    }
  },
  async created () {
    if (this.$route.query.usrid && this.$route.query.usr_token) {
      let params = {
        usr_id: this.$route.query.usrid,
        usr_token: this.$route.query.usr_token
      }
      try {
        await api.checkResetPasswordLink(params);
        this.isValid = true;
      } catch (error) {
        let msg = {
          message: this.$t('resetPassword.resetLinkExpired')
        }
        this.EventBus.$emit('error', msg);
        this.$router.push('/forgotpassword');
      }
    } else {
    this.$router.push('/');
    }
  },
  methods: {
    async resetPassword () {
      if (this.hasErrors()) {
        return;
      }
      let params = {
        usr_id: this.$route.query.usrid,
        usr_token: this.$route.query.usr_token,
        usr_password: this.password.value
      }
      try {
        await api.resetPassword(params);
        let msg = {
          message: this.$t('login.passwordChanged')
        }
        this.EventBus.$emit('info', msg);
        this.$router.push('/login');
      } catch (error) {
        this.handleError(error);
      }
    },
    hasErrors () {
      this.clearErrors();
      this.validatePassword();
      this.validateRepeatPassword();

      if (this.password.errors.length !== 0 || this.repeatPassword.errors.length !== 0) {
        return true;
      } else {
        return false;
      }
    },
    clearErrors () {
      this.password.errors = [];
      this.repeatPassword.errors = [];
    },
    validatePassword () {
      if (this.password.value === '') {
        this.password.errors.push(this.$t('register.passwordEmptyError'))
      }

      if (this.password.value.length < 8) {
        this.password.errors.push(this.$t('register.passwordError'))
      }
    },
    validateRepeatPassword () {
      if (this.repeatPassword.value === '') {
        this.repeatPassword.errors.push(this.$t('register.confirmPasswordEmptyError'))
      }

      if (this.password.value !== this.repeatPassword.value) {
        this.repeatPassword.errors.push(this.$t('register.confirmPasswordError'))
      }
    }
  }
}
</script>

<style scoped lang='scss'>
.input {
    margin: 15px 0;
    span {
        margin-bottom: 3px;
    }
    small {
        color: red;
        display: block;
    }
    input {
        transition: border-color .2s ease;
        &.error {
            border-color: red;
        }
    }
}
.logo-wrap {
  display: none;
}
.button-wrap {
    margin: 30px 0 0 0;
    display: flex;
    justify-content: flex-end;
}
.button-round {
    background: var(--button-color-yellow);
}
</style>